
























import { cloneDeep } from 'lodash'
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import ImageUploadItem from './ImageUploadItem.vue'
import Upload from '@/components/Upload/index.vue'
import VisitorApi from '@/api/visitor'
import { updateViewer } from '@/utils/util'
let viewer: any = ''

@Component({
	components: {
		ImageUploadItem,
		Upload,
	},
})
export default class ImagesUploads extends Vue {
	private loading = false

	@Prop({})
	private imageBlocks!: {
		name: string
		type: string
		maxNum?: number
	}[]

	@Prop({})
	private sizeLimit?: number

	@Prop({ default: () => ({}) })
	private mediaMap!: any // 已上传成功的图片Map

	@Prop({ default: false })
	private isReadonly!: boolean

	@Watch('mediaMap', { immediate: true })
	private onMapChange() {
		if (Object.keys(this.mediaMap || {}).length <= 0) {
			return
		}

		this.updateViewer()
	}

	private updateViewer() {
		this.$nextTick(() => {
			viewer = updateViewer(viewer, '.block-wrapper')
		})
	}

	private deactivated() {
		viewer && viewer.destroy()
		viewer = ''
	}

	private beforeDestroy() {
		viewer && viewer.destroy()
		viewer = ''
	}

	private async addPic(type: string) {
		if (this.loading) {
			return
		}

		const block: any = this.imageBlocks.find((item: any) => item.type === type)
		if (!block) {
			return
		}
		const images = block.isMultiple
			? await (this.$refs.upload as any).get()
			: await (this.$refs.upload as any).getSingle()

		const currentImageNum =
			(this.mediaMap[type] && this.mediaMap[type].length) || 0
		if (block.maxNum && currentImageNum + images.length > block.maxNum) {
			this.$message.error(`最多上传${block.maxNum}张`)
		} else {
			this.uploadImages(type, images)
		}
	}

	// 上传图片到影像服务 并更新原有mediaMap
	// index存在时为替换图片 不存在则为新增图片
	private uploadImages(type: string, images: any[], index?: number) {
		this.loading = true
		// duration设置为0 不自动关闭
		const hide = this.$message.loading('上传中...', 0)

		let count = 0,
			suc = 0
		for (let image of images) {
			const formData = new FormData()
			formData.append('filecontent', image)

			VisitorApi.operateAndUpload({
				formData,
				params: {
					cmd: 'imageMogr2/thumbnail/800x800',
				},
			})
				.then((res: any) => {
					this.imagesUploaded(type, res.data && res.data.picId, image, index)
					if (++suc === images.length) {
						this.$message.success('上传成功')
					}
				})
				.finally(() => {
					if (++count === images.length) {
						hide()
						this.loading = false
					}
				})
		}
	}

	private imagesUploaded(
		type: string,
		picId: string,
		image: File,
		index?: number
	) {
		if (!picId) {
			return console.error(`${image.name}上传的picId不存在`)
		}
		const reader = new FileReader()
		reader.readAsDataURL(image)
		reader.onload = () => {
			const mediaMap = cloneDeep(this.mediaMap)
			if (!mediaMap[type]) {
				mediaMap[type] = []
			}
			if (index || index === 0) {
				// 重新上传的图片
				mediaMap[type].splice(index, 1, {
					picId: picId,
					picUrl: reader.result,
					picName: image.name,
				})
			} else {
				mediaMap[type].push({
					picId: picId,
					picUrl: reader.result,
					picName: image.name,
				})
			}

			this.$emit('change', mediaMap)
		}
	}

	private removePic({ type, picId }: { type: string; picId: string }) {
		const mediaMap = cloneDeep(this.mediaMap)
		const currentMediaBlock = mediaMap && mediaMap[type]
		if (!currentMediaBlock) {
			console.error(`模块不存在${type}类型图片`)
			return
		}
		const picIndex = currentMediaBlock.findIndex(
			(imgObj: any) => imgObj.picId === picId
		)
		currentMediaBlock.splice(picIndex, 1)
		this.$emit('change', mediaMap)
	}

	private async reuploadPic({ type, index }: { type: string; index: number }) {
		const image = await (this.$refs.upload as any).getSingle()
		this.uploadImages(type, [image], index)
	}
}
